"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _redux = require("redux");

var _I18n = _interopRequireDefault(require("I18n"));

var _actions = require("settings-ui-sdk/Hubs/actions");

var _actions2 = require("settings-ui-sdk/I18n/actions");

var _actions3 = require("settings-ui-sdk/PortalSettings/actions");

var _actions4 = require("settings-ui-sdk/MultiCurrency/actions");

var _AppActions = require("settings-ui-sdk/actions/AppActions");

var _AccountDefaultsActions = require("../actions/AccountDefaultsActions");

var _selectors = require("../selectors");

var _SettingsStickySaveFooter = _interopRequireDefault(require("settings-ui-lib/components/SettingsStickySaveFooter"));

var _accountDefaultsAccessControl = _interopRequireDefault(require("./hoc/accountDefaultsAccessControl"));

var _TabsContainer = _interopRequireDefault(require("./TabsContainer"));

var AccountDefaultsContainer =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(AccountDefaultsContainer, _PureComponent);

  function AccountDefaultsContainer() {
    (0, _classCallCheck2.default)(this, AccountDefaultsContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AccountDefaultsContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(AccountDefaultsContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.loadHub();
      this.props.loadI18nOptions();
      this.props.loadI18nSetting();
      this.props.loadPortalSettings();
      this.props.loadMultiCurrencyActive();
      this.props.loadMultiCurrencyCodes();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          stagedChangesCount = _this$props.stagedChangesCount,
          canSave = _this$props.canSave,
          dispatch = (0, _objectWithoutProperties2.default)(_this$props, ["children", "stagedChangesCount", "canSave"]);
      return _react.default.createElement("div", {
        className: "m-bottom-10"
      }, _react.default.createElement(_TabsContainer.default, null), children, _react.default.createElement(_SettingsStickySaveFooter.default, {
        saveDisabled: !canSave,
        description: _I18n.default.text('settingsui.pendingChanges', {
          count: stagedChangesCount
        }),
        shouldRender: stagedChangesCount > 0,
        onCancel: dispatch.resetStagedChanges,
        onSave: dispatch.saveStagedChanges
      }));
    }
  }]);
  return AccountDefaultsContainer;
}(_react.PureComponent);

AccountDefaultsContainer.propTypes = {
  children: _propTypes.default.node,
  loadHub: _propTypes.default.func.isRequired,
  loadI18nOptions: _propTypes.default.func.isRequired,
  loadI18nSetting: _propTypes.default.func.isRequired,
  loadPortalSettings: _propTypes.default.func.isRequired,
  loadMultiCurrencyActive: _propTypes.default.func.isRequired,
  loadMultiCurrencyCodes: _propTypes.default.func.isRequired,
  stagedChangesCount: _propTypes.default.number.isRequired,
  resetStagedChanges: _propTypes.default.func.isRequired,
  saveStagedChanges: _propTypes.default.func.isRequired,
  canSave: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    stagedChangesCount: (0, _selectors.getStagedChangesCount)(state),
    canSave: (0, _selectors.getCanSave)(state)
  };
};

var _default = (0, _redux.compose)(_accountDefaultsAccessControl.default, (0, _reactRedux.connect)(mapStateToProps, {
  loadHub: _actions.loadHub,
  loadI18nOptions: _actions2.loadI18nOptions,
  loadI18nSetting: _actions2.loadI18nSetting,
  loadPortalSettings: _actions3.loadPortalSettings,
  loadMultiCurrencyActive: _actions4.loadMultiCurrencyActive,
  loadMultiCurrencyCodes: _actions4.loadMultiCurrencyCodes,
  saveStagedChanges: _AccountDefaultsActions.saveStagedChanges,
  resetStagedChanges: _AppActions.resetStagedChanges
}))(AccountDefaultsContainer);

exports.default = _default;
module.exports = exports.default;